<template>
  <div id="app_settings">
    <v-layout wrap justify-center>
      <v-flex pa-4>
        <v-card id="app_height">
          <Settings />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Settings from "./../Settings/settings";
export default {
  components: {
    Settings
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
#app_settings {
  background-image: url("../../assets/home_header.png");
  /* background-color: #26af82; */
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

#app_height {
  min-height: 80vh;
}
</style>